import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class PriceFormatEUR extends Component {
    intl = new Intl.NumberFormat('sk', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: this.props.hasOwnProperty('minimumFractionDigits')
            ? this.props.minimumFractionDigits
            : 2
    });
    render() {
        if (window.Intl && typeof window.Intl === 'object') {
            return <span>{this.intl.format(this.props.value)}</span>;
        } else {
            return <span>{this.props.value}€</span>;
        }
    }
}

PriceFormatEUR.propTypes = {
    value: PropTypes.number.isRequired,
    minimumFractionDigits: PropTypes.number
};
